import { getTableName } from 'drizzle-orm'
import type { PgTable } from 'drizzle-orm/pg-core'

type ColumnKey<T extends PgTable> = keyof T['_']['columns'] & string

// What the AI assistant is told about a table beyond what information_schema
// already says (names, types, enums, foreign keys). Keyed by the Drizzle
// property name, so a renamed or dropped column fails type-check here instead
// of quietly leaving a stale description behind.
export interface TableDoc<T extends PgTable = PgTable> {
  // What one row is, when it is written, and every trap a query author must
  // know (VAT, import artefacts, which date means what).
  description: string
  columns?: Partial<Record<ColumnKey<T>, string>>
  // The readonly role gets no SELECT on this table at all.
  aiAccess?: 'denied'
  // Credential-bearing columns the readonly role is not granted; the rest of
  // the table stays queryable. `SELECT *` fails on such a table, so the
  // assistant is told to list columns.
  hiddenColumns?: ColumnKey<T>[]
}

export const tableDocs = new Map<string, TableDoc>()

export function describeTable<T extends PgTable>(table: T, doc: TableDoc<T>) {
  tableDocs.set(getTableName(table), doc as TableDoc)
}
